/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * BaseLayout.tsx
 */

import React from 'react';
import {Route, Router, Switch} from "react-router-dom";

import App from './App';
import HomePage from './component/page/HomePage';
import HiloReactComponent from "./tools/view/layout/HiloReactComponent";
import LoginPage from "./component/page/LoginPage";
import User from "./models/User";
import NotFound from "./tools/view/element/NotFound";
import CategoryPage from "./component/page/CategoryPage";
import CategoriesPage from "./component/page/CategoriesPage";
import VideoPage from "./component/page/VideoPage";
import CatalogsPage from "./component/page/CatalogsPage";
import CatalogPage from "./component/page/CatalogPage";
import ProfilesPage from "./component/page/ProfilesPage";
import ProfilePage from "./component/page/ProfilePage";

interface Props {
    user?: User
}

export default class Container extends HiloReactComponent<Props, {}> {
    public render() {
        if (this.props.user) {
            return <Router history={App.history}>
                <Switch>
                    <Route path={"/"} exact component={HomePage}/>
                    <Route path={"/categories"} exact component={CategoriesPage}/>
                    <Route path={"/category/:id"} exact component={CategoryPage}/>
                    <Route path={"/catalogs"} exact component={CatalogsPage}/>
                    <Route path={"/catalog/:id"} exact component={CatalogPage}/>
                    <Route path={"/profiles"} exact component={ProfilesPage}/>
                    <Route path={"/profile/:id"} exact component={ProfilePage}/>
                    <Route path={"/category/:categoryId/video/:videoId"} exact component={VideoPage}/>
                    <Route path={"*"} component={NotFound}/>
                </Switch>
            </Router>;
        } else {
            return <Router history={App.history}>
                <Switch>
                    <Route path={"/"} exact component={LoginPage}/>
                    <Route path={"*"} component={NotFound}/>
                </Switch>
            </Router>;
        }
    }
}
